import * as React from "react";
const SvgChat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M38 42h.01M42 42h.01M46 42h.01M51 42c0 4.418-4.03 8-9 8a9.9 9.9 0 0 1-4.255-.949L33 50l1.395-3.72C33.512 45.042 33 43.574 33 42c0-4.418 4.03-8 9-8s9 3.582 9 8"
    />
  </svg>
);
export default SvgChat;
